import { RefObject } from 'react';
import { useWindowSize } from 'react-use';
import useKbygRewindsFullscreen from 'components/CamPlayerKbygRewinds/useKbygRewindsFullscreen/useKbygRewindsFullscreen';
import { Player } from 'components/CamPlayerKbygRewinds/usePlayerState/usePlayerState';
import { VideoPlayerHandle } from 'components/VideoPlaylistPlayer/VideoPlaylistPlayer';

export const useCornerControls = ({
  videoPlayerRef,
}: {
  videoPlayerRef: RefObject<VideoPlayerHandle>;
}) => {
  const { height, width } = useWindowSize();

  const { fullscreenElementRef, isFullscreen, supportsFullscreen, handleRequestFullscreen } =
    useKbygRewindsFullscreen({
      width,
      height,
      multiCamViewActive: false,
      currentPreviewPlayer: Player.REWIND,
      liveCamPlayerHandle: videoPlayerRef,
      rewindCamPlayerHandle: videoPlayerRef,
    });

  return {
    fullscreenElementRef,
    handleRequestFullscreen,
    isFullscreen,
    supportsFullscreen,
  };
};

export default useCornerControls;
